import { NgModule } from '@angular/core';
import { ConfirmationModalContent } from "@bt/confirmation-modal/confirmation.modal";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  imports: [
    FontAwesomeModule,
  ],
  entryComponents: [ConfirmationModalContent],
  providers:[],
  declarations: [
    ConfirmationModalContent,
  ],
})

export class ConfirmationModalModule {
}



// WEBPACK FOOTER //
// ./src/app/confirmation-modal/confirmation.module.ts